import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../../custom-hooks/useAuth';
import { toast } from 'react-toastify';

const AdminRoute = ({ children }) => {
  const { currentUser, loading, verified } = useAuth();
  const location = useLocation();

  // Wait for the live auth state and the role read from Firestore (not the local cache).
  if (loading || !verified) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: '60vh' }}
      >
        <div
          className="spinner-border text-warning mb-3"
          role="status"
          style={{ width: '3rem', height: '3rem', color: '#c59b27' }}
        >
          <span className="visually-hidden">Loading Atelier Command Center...</span>
        </div>
        <p className="text-muted fw-semibold">Verifying Atelier Administrator Credentials...</p>
      </div>
    );
  }

  // Check if logged in
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Admin is decided by users/{uid}.role in Firestore. This is only a UI guard:
  // the real enforcement is in firestore.rules.
  const isAdmin = currentUser.role === 'admin';

  if (!isAdmin) {
    toast.error('Access restricted. Atelier Command Center requires administrator credentials.');
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
